<template>
	<div>
		<h1>{{ $t('settings') }}</h1>

		<!-- General -->
		<div class="list-group border-radius-2 no-border mb-3">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('general') }}</h2></div>
			<router-link to="/settings/general" class="list-group-item">{{ $t('language') }}</router-link>
			<a href="#" @click.prevent="updateApp()" class="list-group-item">{{ $t('update-app') }}</a>
			<router-link to="/settings/retryrequests" class="list-group-item">{{ $t('retry-requests') }}</router-link>
			<router-link to="/changelog/" class="list-group-item">{{ $t('change-log') }}</router-link>
            <router-link 
                v-if="hasPriv('PROFILE_PICTURE_UPLOAD_EDIT')"
                to="/settings/users/profile-picture/" class="list-group-item">{{ $t('profile-picture') }}</router-link>
            <router-link to="/settings/change-password" class="list-group-item">{{ $t('change-password') }}</router-link>
		</div>

		<!-- Tags -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('MANAGE_TAGS')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('configuration') }}</h2></div>
			<router-link to="/settings/tagmanager" class="list-group-item" v-if="hasPriv('MANAGE_TAGS')">{{ $t('tag-manager') }}</router-link>
			<router-link to="/settings/taggroups" class="list-group-item" v-if="hasPriv('MANAGE_TAGS')">{{  $t('tag-groups') }}</router-link>
		</div>

		<!-- Users & Roles -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('USER_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('users') }}</h2></div>
			<router-link to="/settings/users" class="list-group-item">{{ $t('manage-users') }}</router-link>
			<router-link to="/settings/users/roles" class="list-group-item">{{ $t('manage-roles') }}</router-link>
			<router-link to="/settings/programme" class="list-group-item">{{ $t('manage-programs') }}</router-link>
			<router-link to="/settings/grouptypes" class="list-group-item">{{ $t('student-groups') }}</router-link>
		</div>

		<!-- Compentency Tests -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('COMPTEST_MANAGE') && $config.hasModule('tests')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('tests') }}</h2></div>
			<router-link to="/settings/competencytests" class="list-group-item">{{ $t('tests') }}</router-link>
			<router-link to="/settings/competencytests/filters" class="list-group-item">{{ $t('test-filters') }}</router-link>
		</div>

		<!-- Reports -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('THIRDPARTYDATA_MANAGE')||hasPriv('REPORTDATAELEMENTEDITOR')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('reports') }}</h2></div>
			<router-link to="/settings/reports/dataelements" class="list-group-item"  v-if="hasPriv('REPORTDATAELEMENTEDITOR')">{{ $t('report-data-elements') }}</router-link>
			<router-link to="/settings/reports/config" class="list-group-item"  v-if="hasPriv('REPORTDATAELEMENTEDITOR')">{{ $t('report-editor') }}</router-link>
			<router-link to="/thirdparty/edit" class="list-group-item"  v-if="hasPriv('THIRDPARTYDATA_MANAGE')">{{ $t('third-party-data') }}</router-link>
            <a href="#" @click.prevent="clearCache()" class="list-group-item">{{ $t('clear-cache') }}</a>
		</div>

		<!-- Forms -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('EDIT_FORMS')||hasPriv('MANAGE_WORKBOOKS')">
			<!--<router-link to="/formeditor/home" class="list-group-item">
				<h2 class="mb-0 mt-0 pt-0 pb-0">
					<b-icon icon="chevron-right" class="float-right pt-1"></b-icon>
					{{ $t('forms') }}
				</h2>
			</router-link>-->
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('forms') }}</h2></div>
			<template v-if="hasPriv('EDIT_FORMS')">
				<router-link to="/formeditor/forms" class="list-group-item">{{ $t('forms') }}</router-link>
				<router-link to="/settings/workflows" class="list-group-item">{{ $t('workflows') }}</router-link>
                <router-link to="/settings/static-urls" class="list-group-item">{{ $t('static-urls') }}</router-link>
				<router-link to="/formeditor/formlibrary/field" class="list-group-item">{{ $t('form-library-fields') }}</router-link>
                <router-link to="/formeditor/formlibrary/fieldgroup" class="list-group-item">{{ $t('form-library-field-groups') }}</router-link>
				<router-link to="/formeditor/formlibrary/selectoptions" class="list-group-item">{{ $t('form-library-options') }}</router-link>
				<router-link to="/formeditor/questionbank" class="list-group-item">{{ $t('question-bank') }}</router-link>
				<router-link to="/formeditor/responsevaluegroups" class="list-group-item">{{ $t('response-value-groups') }}</router-link>
				<!--<router-link to="/formeditor/formschedules" class="list-group-item">{{ $t('form-schedules') }}</router-link>-->
			</template>
			<router-link to="/settings/workbooks" class="list-group-item" v-if="hasPriv('MANAGE_WORKBOOKS')">{{ $t('workbooks') }}</router-link>
		</div>
		
        <!-- Messages -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('MESSAGES_ALL')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('messages') }}</h2></div>
			<router-link to="/messages/allsent" class="list-group-item" v-if="hasPriv('MESSAGES_ALL')">{{ $t('view-sent-messages') }}</router-link>
		</div>

        <!-- OSCE -->
        <div class="list-group border-radius-2 no-border mb-3" v-if="hasModule('osce')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('osce') }}</h2></div>
			<template v-if="hasPriv('OSCE_ADMIN')">
				<router-link to="/settings/osce" class="list-group-item">{{ $t('osce-workflows') }}</router-link>
			</template>
		</div>
		
		<!-- Interfaces -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('APPINTERFACE_MANAGE') && $config.hasModule('clinical')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('clinical-interface') }}</h2></div>
			<router-link to="/settings/interfaceeditor/procedures" class="list-group-item">{{ $t('procedures') }}</router-link>
			<router-link to="/settings/interfaceeditor/sections" class="list-group-item">{{ $t('sections') }}</router-link>
		</div>

		<!-- System -->
		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('MASTER_CONFIG')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('system') }}</h2></div>
			<router-link to="/settings/maintenancemode" class="list-group-item">{{ $t('maintenance-mode') }}</router-link>
			<router-link to="/settings/languageoverrides" class="list-group-item">{{ $t('language-overrides') }}</router-link>
			<router-link to="/settings/configuration" class="list-group-item">{{ $t('configuration-settings') }}</router-link>
		</div>



		<div class="list-group border-radius-2 no-border mb-3" v-if="hasPriv('CURRICULUMMAP_MANAGE')">
			<div class="list-group-item"><h2 class="mb-0 mt-0 pt-0 pb-0">{{ $t('curriculum-mapping') }}</h2></div>
			<router-link to="/curriculum-mapping" class="list-group-item">{{ $t('curriculum-mapping') }}</router-link>
			<router-link to="/curriculum-mapping/learning-outcomes" class="list-group-item">{{ $t('learning-outcomes') }}</router-link>
			<router-link to="/curriculum-mapping/learning-outcomes/unmapped" class="list-group-item">{{ $t('unmapped-learning-outcomes') }}</router-link>
		</div>
	</div>
</template>

<script>

export default {
	components: {
	},
	data: function() {
		return {
			activeItem: null
		};
	},
	mounted() {

	},
	methods: {
		hasPriv(priv) {
			return this.$UserSession.hasPriv.call(this, priv);
		},
        hasModule(module) {
            return this.$config.hasModule(module)
        },
		updateApp: function() {
			location.reload();
		},
		updateApp2: function() {
			window.location.reload(true);
		},
        clearCache(){
            return this.$cfetch(`${this.$settings.APIBaseURL}/reporting/clearcache`, {
				cache: false,
                method: 'post'
			})
			.then(res => {
				if (res.status === "SUCCESS") {
					this.$log.info.call(this, "Cache cleared");
                    this.$store.commit("openDialog", {
                        title: this.$t("success"),
                        content: this.$t("the-cache-has-been-cleared")
                    });
				} else {
					this.$log.error.call(this, "Unsuccesful API call");
					this.$store.commit("openDialog", {
                        title: this.$t("oops"),
                        content: this.$t("something-went-wrong")
                    });
				}
			})
			.catch(error => {
				this.$log.error.call(this, error);
                console.log(error);
			});
        }
	},
	computed: {
		canManageTags() {
			return this.$UserSession.hasPriv.call(this, "MANAGE_TAGS")
		}
	}
};
</script>
